var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-virtual-scroll',{attrs:{"items":_vm.items,"height":_vm.computedHeight,"item-height":_vm.itemHeight},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_vm._t("default",null,null,{ item: item, index: index })]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }